jQuery(function($) {
  $('.hero__slider__wrap').flickity({
    pageDots: false,
    arrowShape: 'm79,8.3q0,1.3-1,2.3l-39,39,39,39q1,1,1,2.3t-1,2.3l-5,5q-1,1-2.3,1t-2.3-1l-47-46q-1-1-1-2.3t1-2.3l47-47q1-1,2-1,1.3,0,2.3,1l5,5q1,1,1,2.3z',
    imagesLoaded: true,
    wrapAround: true
  });
});